import { render, staticRenderFns } from "./itemDetail.vue?vue&type=template&id=3cf35da6&scoped=true"
import script from "./itemDetail.vue?vue&type=script&lang=js"
export * from "./itemDetail.vue?vue&type=script&lang=js"
import style0 from "./itemDetail.vue?vue&type=style&index=0&id=3cf35da6&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf35da6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3875257498/src/codestar-connections.ap-northeast-1.amazonaws.com/git-http/364953906322/ap-northeast-1/84d36ee7-16b8-4e80-bff0-7e6a249efe8b/OwlTing/owlnest_booking_engine/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cf35da6')) {
      api.createRecord('3cf35da6', component.options)
    } else {
      api.reload('3cf35da6', component.options)
    }
    module.hot.accept("./itemDetail.vue?vue&type=template&id=3cf35da6&scoped=true", function () {
      api.rerender('3cf35da6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/itemDetail.vue"
export default component.exports